import {
    injectIntl
} from 'react-intl';
import flatten from 'flat';

import intlAR from './local-data/ar';
import intlZH from './local-data/zh';
import intlEN from './local-data/en';
import intlFR from './local-data/fr';
import intlRU from './local-data/ru';
import intlES from './local-data/es';

import ar from './translations/ar.json';
import zh from './translations/zh.json';
import en from './translations/en.json';
import fr from './translations/fr.json';
import ru from './translations/ru.json';
import es from './translations/es.json';

injectIntl([...intlAR, ...intlZH, ...intlEN, ...intlFR, ...intlRU, ...intlES]);

const locales = {
    ar: flatten(ar),
    zh: flatten(zh),
    en: flatten(en),
    fr: flatten(fr),
    ru: flatten(ru),
    es: flatten(es)
};

export default locales;